import React, { Component } from 'react';
import { AppCollapsible } from '../AppCollapsible';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';
import { createGlobalStyle } from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './date.css';

const DatePickerWrapperStyles = createGlobalStyle`
    .date-container .react-datepicker__day--selected,
    .date-container .react-datepicker__day--keyboard-selected
    {
        background-color: ${props => props.color};
    }
    
    .date-container .react-datepicker__day--selected:hover,
    .date-container .react-datepicker__day--keyboard-selected:hover
    {
        background-color: ${props => props.color};
    }
    
    .date-container .react-datepicker__current-month {
        color: ${props => props.color};
    }
    
    .date-container .app-date-picker {
        color: ${props => props.color};
        border-color: ${props => props.color};
    }
`;


class DateInput extends Component {

    constructor(props) {
        super(props);
        this.datePickerRef = React.createRef();
    };

    state = {
        label: this.props.initialValues.label || 'Date fields',
        required: this.props.initialValues.isRequired || false,
        date: '',
        requiredError: !!this.props.initialValues.isRequired,
        dateString: '',
    };

    updateInputPropsInStore = () => {
        const { label, required, date, dateString } = this.state;

        const inputProps = {
            label,
            isRequired: required,
            type: this.props.initialValues.type,
            _value: dateString,
            _hasValidationErrors: this.state.requiredError,
        };

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    setLabel = (e) => {
        this.setState({ label: e.target.value })
    };

    setRequired = (e) => {
        this.setState({ required: e.target.checked })
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
        this.setDatePickerPlaceholder();
    };

    componentDidUpdate() {
        this.updateInputPropsInStore();
    };

    setDatePickerPlaceholder = () => {
        this.datePickerRef.current.input.placeholder = 'Date';
    };

    handleChangeDate = (date) => {
        const dateString = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        console.log(dateString(date));
        console.log(date)
        let dateStr = dateString(date);
        this.setState({ date: date, dateString: dateStr }, () => {
            this.updateRequiredError();
        });
    };

    updateRequiredError = () => {
        let requiredError;
        if (!this.state.required) {
            requiredError = false;
        } else {
            requiredError = !(this.state.date);
        }
        this.setState({ requiredError });
    };

    render() {
        const { color, textColor, isResultInput } = this.props;
        return (
            <>
                <AppInputWrapper
                    label={this.state.label}
                    color={textColor}
                    required={this.state.required}
                    requiredError={this.state.requiredError}
                >
                    <div className="date-container">
                        <DatePicker
                            ref={this.datePickerRef}
                            className="form-control app-default-select app-date-picker"
                            selected={this.state.date}
                            onSelect={this.handleChangeDate}
                        />
                        <DatePickerWrapperStyles color={color} />
                    </div>
                </AppInputWrapper>
                {
                    !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">
                            <label>
                                <input value={this.state.label} onChange={this.setLabel} type="text"/>
                                label
                            </label>

                            <label>
                                <input checked={this.state.required} onChange={this.setRequired} type="checkbox"/>
                                required
                            </label>

                        </div>
                    </AppCollapsible>
                }

            </>
        );
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(DateInput);
